<script>
/**
 * S3 object key로 Presigned URL을 조회하여 썸네일 이미지를 표시하는 컴포넌트.
 */
import { getPresignedUrl } from '@/api/attachment.js'

export default {
  name: 'ProductThumbnail',

  props: {
    /** S3 object key (file_location) */
    objectKey: {
      type: String,
      default: '',
    },
    /** 이미지 크기 (px) */
    size: {
      type: [Number, String],
      default: 48,
    },
  },

  data() {
    return {
      imageUrl: null,
      loading: false,
      error: false,
    }
  },

  watch: {
    objectKey: {
      immediate: true,
      handler(val) {
        this.imageUrl = null
        this.error = false
        if (val) this.fetchUrl()
      },
    },
  },

  methods: {
    async fetchUrl() {
      if (!this.objectKey) return
      this.loading = true
      try {
        const res = await getPresignedUrl(this.objectKey)
        if (res.data?.code === 0 && res.data?.presignedUrl) {
          this.imageUrl = res.data.presignedUrl
        } else {
          this.error = true
        }
      } catch (e) {
        this.error = true
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<template>
  <div
    class="thumbnail-wrap"
    :style="{ width: size + 'px', height: size + 'px' }"
  >
    <v-img
      v-if="imageUrl"
      :src="imageUrl"
      :width="size"
      :height="size"
      cover
      class="rounded"
    />
    <div
      v-else-if="loading"
      class="d-flex align-center justify-center rounded bg-grey-lighten-3"
    >
      <v-progress-circular indeterminate size="20" />
    </div>
    <div
      v-else
      class="d-flex align-center justify-center rounded bg-grey-lighten-3  w-full h-full"
    >
      <v-icon size="20" color="grey">mdi-image-off-outline</v-icon>
    </div>
  </div>
</template>

<style scoped>
.thumbnail-wrap {
  min-width: 80px;
  min-height: 80px;
  border-radius: 6px;
  overflow: hidden;
}
</style>
